// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_JSON from "@rescript/runtime/lib/es6/Stdlib_JSON.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as RelaySSRUtils from "./RelaySSRUtils.re.mjs";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as WebFetch from "@remix-run/web-fetch";
import * as RelayRouter__NetworkUtils from "./RelayRouter__NetworkUtils.re.mjs";

function preloadFromResponse(part, preloadAsset) {
  let obj = Stdlib_JSON.Decode.object(part);
  if (obj === undefined) {
    return;
  }
  let extensions = obj["extensions"];
  if (extensions === undefined) {
    return;
  }
  let extensions$1 = Stdlib_JSON.Decode.object(extensions);
  if (extensions$1 !== undefined) {
    Stdlib_Option.getOr(Stdlib_Option.map(extensions$1["preloadableImages"], images => Stdlib_Array.filterMap(Stdlib_Option.getOr(Stdlib_JSON.Decode.array(images), []), item => Stdlib_JSON.Decode.string(item))), []).forEach(imgUrl => preloadAsset("Default", {
      TAG: "Image",
      url: imgUrl
    }));
    return;
  }
}

function sequence(xs) {
  return Stdlib_Array.filterMap(xs, x => x);
}

let OptionArray = {
  sequence: sequence
};

let GraphQLIncrementalResponse = {};

function mapIncrementalWithDefault(t, withIncremental, $$default) {
  if (t.TAG === "Incremental") {
    return withIncremental(t._0);
  } else {
    return $$default(t._0);
  }
}

function fromIncremental(data) {
  return {
    TAG: "Incremental",
    _0: data
  };
}

function makeResponse(data) {
  return {
    TAG: "Response",
    _0: data
  };
}

function parse(json, parseFn) {
  let dict = Stdlib_JSON.Decode.object(json);
  if (dict === undefined) {
    return;
  }
  let data = dict["incremental"];
  if (data !== undefined) {
    let arrayData = Stdlib_JSON.Decode.array(data);
    if (arrayData !== undefined) {
      let xs = arrayData.map(parseFn);
      return Stdlib_Option.flatMap(Stdlib_Array.filterMap(xs, x => x), data => ({
        TAG: "Incremental",
        _0: {
          incremental: data,
          hasNext: Stdlib_Option.mapOr(dict["hasNext"], false, v => Stdlib_Option.mapOr(Stdlib_JSON.Decode.bool(v), false, v => v))
        }
      }));
    }
    let data$1 = parseFn(json);
    if (data$1 !== undefined) {
      return {
        TAG: "Response",
        _0: Primitive_option.valFromOption(data$1)
      };
    } else {
      return;
    }
  }
  let data$2 = parseFn(json);
  if (data$2 !== undefined) {
    return {
      TAG: "Response",
      _0: Primitive_option.valFromOption(data$2)
    };
  }
}

function fromJson(json) {
  let dict = Stdlib_JSON.Decode.object(json);
  if (dict === undefined) {
    return {
      TAG: "Response",
      _0: json
    };
  }
  let data = dict["incremental"];
  if (data === undefined) {
    return {
      TAG: "Response",
      _0: json
    };
  }
  let arrayData = Stdlib_JSON.Decode.array(data);
  if (arrayData !== undefined) {
    return {
      TAG: "Incremental",
      _0: {
        incremental: arrayData,
        hasNext: Stdlib_Option.mapOr(dict["hasNext"], false, v => Stdlib_Option.mapOr(Stdlib_JSON.Decode.bool(v), false, v => v))
      }
    };
  } else {
    return {
      TAG: "Response",
      _0: json
    };
  }
}

let GraphQLResponse = {
  mapIncrementalWithDefault: mapIncrementalWithDefault,
  fromIncremental: fromIncremental,
  makeResponse: makeResponse,
  parse: parse,
  fromJson: fromJson
};

function fromIncrementalResponse(param) {
  let hasNext = param.hasNext;
  let incremental = param.incremental;
  return incremental.map((data, i) => {
    let hasNext$1 = i === (incremental.length - 1 | 0) ? hasNext : true;
    return Object.assign(data, {
      hasNext: hasNext$1,
      extensions: {
        is_final: !hasNext$1
      }
    });
  });
}

function fromJsonIncrementalResponse(param) {
  let hasNext = param.hasNext;
  let incremental = param.incremental;
  return incremental.map((data, i) => {
    let hasNext$1 = i === (incremental.length - 1 | 0) ? hasNext : true;
    return Object.assign({}, data, {
      hasNext: hasNext$1,
      extensions: {
        is_final: !hasNext$1
      }
    });
  });
}

let RelayDeferResponse = {
  fromIncrementalResponse: fromIncrementalResponse,
  fromJsonIncrementalResponse: fromJsonIncrementalResponse
};

function adaptJsonIncrementalResponseToRelay(part) {
  return mapIncrementalWithDefault(fromJson(part), fromJsonIncrementalResponse, part => [part]);
}

function makeFetchQuery() {
  return RelaySSRUtils.makeClientFetchFunction((sink, operation, variables, _cacheConfig, _uploads) => {
    fetch(import.meta.env.DEV ? Stdlib_Option.getOr(import.meta.env.VITE_API_ENDPOINT, "http://localhost:4000/graphql") : "/graphql", {
      method: "POST",
      credentials: "include",
      headers: Object.fromEntries([[
          "content-type",
          "application/json"
        ]]),
      body: Stdlib_Option.getOr(JSON.stringify({
        query: operation.text,
        variables: variables
      }), "")
    }).then(r => RelayRouter__NetworkUtils.getChunks(r, part => {
      adaptJsonIncrementalResponseToRelay(part).map(sink.next);
    }, err => sink.error(err), () => sink.complete()));
  });
}

function makeServerFetchQuery(onQuery, headers) {
  return RelaySSRUtils.makeServerFetchFunction(onQuery, (sink, operation, variables, _cacheConfig, _uploads) => {
    Stdlib_Promise.$$catch(WebFetch.fetch(Stdlib_Option.getOr(import.meta.env.VITE_API_ENDPOINT, "http://localhost:4000/graphql"), {
      mode: "no-cors",
      method: "POST",
      headers: Object.fromEntries(Object.entries(headers).concat([[
          "content-type",
          "application/json"
        ]])),
      body: Stdlib_Option.getOr(JSON.stringify({
        query: operation.text,
        variables: variables
      }), "")
    }).then(r => RelayRouter__NetworkUtils.getChunks(r, part => {
      adaptJsonIncrementalResponseToRelay(part).map(sink.next);
    }, err => sink.error(err), () => sink.complete())), e => {
      let err = Stdlib_JsExn.fromException(e);
      sink.error(err !== undefined ? Primitive_option.valFromOption(err) : new Error("GraphQL request failed"));
      return Promise.resolve();
    });
  });
}

export {
  preloadFromResponse,
  OptionArray,
  GraphQLIncrementalResponse,
  GraphQLResponse,
  RelayDeferResponse,
  adaptJsonIncrementalResponseToRelay,
  makeFetchQuery,
  makeServerFetchQuery,
}
/* Stdlib_JsExn Not a pure module */
